var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, ValidateIf } from 'class-validator';
import { IsValidAbsenderIk } from '../../leistungserbringer/validators/institutionskennzeichen.js';
/**
 * Body for `PATCH /office-location-billing-details/:officeLocationId/absender-ik`
 * — the §302 Absender of this Standort (TM-9538 / #1518).
 *
 * ⚠ **`null` is a value here, not an omission.** It clears the Standort's own
 * Absender and hands the question back to the deployment-level
 * Abrechnungsstellen-IK (`GKV_ABRECHNUNGSSTELLE_IK`); with both empty a §302
 * Abrechnungslauf refuses to start. That is a decision a practice can make on
 * purpose, so the field is required and nullable rather than optional — an
 * omitted field and a deliberate clearing would otherwise be the same request.
 *
 * Decorated input (`IK = 260326822`, GR-IK Nr. 3.3) validates: the check
 * normalises first, and so does the entity before it stores.
 */
export class UpdateAbsenderIkDto {
    absenderIk;
}
__decorate([
    ValidateIf((_, value) => value !== null),
    IsString(),
    IsValidAbsenderIk(),
    __metadata("design:type", Object)
], UpdateAbsenderIkDto.prototype, "absenderIk", void 0);
//# sourceMappingURL=update-absender-ik.dto.js.map